package com.wintermar.inspection.feature.presentation.inspection.answer.widget.incomplete

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodyRegular
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_warning_circle
import inspection.composeapp.generated.resources.incomplete_inspection
import inspection.composeapp.generated.resources.total_attention_question
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun IncompleteHeader(
    totalAttentionCount: Int,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    color: ThemeColor = LocalAppTheme.current.color
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(
            space = dimension.spacing.space2,
        ),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(
            painter = painterResource(Res.drawable.ic_warning_circle),
            tint = color.icon.warning.default,
            modifier = Modifier
                .size(dimension.size.icon.m)
                .background(
                    color = color.surface.semantic.warning.subtle.default,
                    shape = RoundedCornerShape(dimension.radius.full)
                )
                .padding(dimension.spacing.space2),
            contentDescription = stringResource(Res.string.incomplete_inspection)
        )

        Column {
            TextBodyRegular(
                text = stringResource(Res.string.incomplete_inspection),
                bold = true
            )

            TextBodySmall(
                text = stringResource(Res.string.total_attention_question, totalAttentionCount),
                color = { it.subtle }
            )
        }
    }
}
